document.addEventListener("DOMContentLoaded", () => {
    const video = document.querySelector(".hero-video-bg");
    if (video) {
        video.playbackRate = 2; // double speed
    }
});